



































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import moment from 'moment';
// @ts-ignore
import { v4 as uuidv4 } from 'uuid';

import MyCommon from '@/mixins/common';
import MyConfig from '@/config';

// @ts-ignore
import COS from 'cos-js-sdk-v5';

const AppInfoParser = require('app-info-parser');

@Component
export default class extends Mixins(MyCommon) {
  @Prop() data!: any;

  @Prop({ default: 'picture-card' }) listType!: string;

  @Prop() value!: any;

  @Prop({ default: false }) disabled!: boolean;

  @Prop({ default: false }) simple!: boolean;

  @Prop({ default: () => ['image/jpeg', 'image/png'] }) fileType!: string[];

  @Prop() beforeCallback!: (...args: any[]) => any;

  @Prop() afterCallback!: (...args: any[]) => any;

  loading = false;

  uploadpercent = 0;

  apiserver: string = MyConfig.casapi;

  headers: any = {
    Authorization: window.localStorage.getItem('token'),
  };

  imageUrl = '';

  uploadType = 'upload';

  @Watch('value')
  async watchValue(newVal: any, oldVal: any) {
    // console.log(newVal)
    console.log("upload:watch",newVal,oldVal)
    if (newVal != oldVal) {
      // this.imageUrl = this.value
      if (_.get(this.data, ['type']) === 'face') {
        const res = await this.getImageUrl(newVal);
        this.imageUrl = String(res);
      } else {
        if (newVal != "") this.imageUrl = this.renderImage(newVal);
      }
    }
  }

  deleteImage() {
    this.imageUrl = "";
    this.$emit('change', '');
  }

  beforeUpload(file: any) {
    if (this.fileType && this.fileType.length > 0) {
      // 需要判断文件格式
      if (!this.fileType.includes(file.type)) {
        this.$message.error(
          `上传文件格式错误${file.type}[需要：${this.fileType.join(',')}]`,
        );
        return false;
      }
    }
    if (file.type === 'application/vnd.android.package-archive') {
      const parser = new AppInfoParser(file);
      parser
        .parse()
        .then((result: any) => {
          // console.log(result);
          this.beforeCallback(result);
        })
        .catch((err: any) => {
          // console.log(err);
        });
    }
    return true;
  }

  customRequest(info: any) {
    // console.log(info);
    const cos: any = new COS({
      getAuthorization: (options: any, callback: any) => {
        // console.log(options);
        // console.log(callback);
        this.$store
          .dispatch('cos/sts', {
            path: options.Pathname,
            type: _.get(this.data, ['type']),
            method: options.Method,
          })
          .then((res: any) => {
            if (res && res.Data) {
              callback({
                TmpSecretId: res.Data.Credentials.TmpSecretId,
                TmpSecretKey: res.Data.Credentials.TmpSecretKey,
                XCosSecurityToken: res.Data.Credentials.Token,
                StartTime: _.get(res, ['Data', '-']),
                ExpiredTime: _.get(res, ['Data', 'ExpiredTime']),
              });
            }
          });
      },
    });

    let bucket = 'tsdata-1257401801';

    if (_.get(this.data, ['type']) === 'face') {
      bucket = 'securedata-1257401801';
    }

    const fileExt: string = info.file.name.substring(
      info.file.name.lastIndexOf('.'),
    );

    let filepath=_.get(this.data, ['filepath']) || '';

    if(!filepath){
      filepath = `/${moment().format(
        'YYYY/MM/DD',
      )}/${uuidv4()}${fileExt}`;
    }

    if (fileExt === '.apk') {
      filepath = `/apks/${moment().format('YYYY/MM/DD')}/${uuidv4()}${fileExt}`;
    }
    cos.putObject(
      {
        Bucket: bucket,
        Region: 'ap-shanghai',
        Key: filepath,
        StorageClass: 'STANDARD',
        Body: info.file,
        onProgress: (progressData: any) => {
          // console.log(progressData);
          this.uploadpercent = progressData.percent * 100;
        },
      },
      (err: any, data: any) => {
        // console.log(err || data);
        if (err) {
          this.$message.error(err);
        } else {
          // 上传成功
          this.uploadpercent = 0
          this.imageUrl = this.renderImage(filepath)
          this.$emit('change', filepath);
        }
      },
    );
  }

  async handleChange(info: any) {
    if (info && info.file.status === 'done') {
      if (_.get(this.data, ['type']) === 'face') {
        const res = await this.getImageUrl(info.file.response.Data);
        this.imageUrl = String(res);
      } else {
        this.imageUrl = this.renderImage(info.file.response.Data)
      }
      // console.log(this.imageUrl)
      // 如果是上传的话，返回的是不带域名的
      this.$emit('change', info.file.response.Data);
    }
  }

  handleRemove() {
    return new Promise((resolve) => {
      this.$confirm({
        title: '确认信息',
        content: '你确定要删除吗？',
        onOk: async () => {
          resolve(true);
        },
        onCancel: () => {
          resolve(false);
        },
      });
    });
  }

  changeInput(e: any) {
    // 如果是填写的，填什么就是什么
    this.imageUrl = e.target.value;
    this.$emit('change', this.imageUrl);
  }

  changeUploadType(t: string) {
    this.uploadType = t;
  }

  async mounted() {
    // if (this.value && this.value.indexOf('https://') !== -1) {
    //   this.uploadType = 'input'
    // }
    if (this.value) {
      // this.imageUrl = this.value
      if (_.get(this.data, ['type']) === 'face') {
        const res = await this.getImageUrl(this.value);
        this.imageUrl = String(res);
      } else {
        this.imageUrl = this.renderImage(this.value);
      }
    }
  }
}
